import KeyIcon from "@mui/icons-material/Key";
import { Alert, Avatar, Box, Button, CircularProgress, TextField, Typography } from "@mui/material";
import { confirmResetPassword, resetPassword } from "aws-amplify/auth";
import { useState } from "react";
import { useNavigate } from "react-router-dom";

import CommonNonAuthenticatedPageLayout from "../components/CommonNonAuthenticatedPageLayout";
import Copyright from "../components/CopyRight";
import { useNonAuthenticated } from "../context/NonAuthenticatedContext";

const PasswordReset = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [confirmationCode, setConfirmationCode] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [newPasswordConfirm, setNewPasswordConfirm] = useState("");
  const [error, setError] = useState("");
  const { username } = useNonAuthenticated();

  const handleConfirmResetPassword = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    setLoading(true);
    if (newPassword !== newPasswordConfirm) {
      setError("Passwords do not match");
    } else {
      await confirmResetPassword({ username, confirmationCode, newPassword })
        .then(() => {
          setError("");
          navigate("/");
        })
        .catch((error: any) => {
          setError(error.message || "An unexpected error occurred");
          console.log(error);
        })
        .finally(() => {
          setLoading(false);
        });
    }
  };

  return (
    <CommonNonAuthenticatedPageLayout>
      <Avatar sx={{ m: 1, bgcolor: "secondary.main" }}>
        <KeyIcon />
      </Avatar>
      <Typography component="h1" variant="h5">
        Reset Password
      </Typography>
      {error && <Alert severity="error">{error}</Alert>}
      <Box component="form" onSubmit={handleConfirmResetPassword} noValidate sx={{ mt: 1, width: "100%" }}>
        <TextField
          margin="normal"
          required
          fullWidth
          id="confirmationCode"
          label="Confirmation Code"
          name="confirmationCode"
          autoComplete="confirmation-code"
          autoFocus
          onChange={(e) => setConfirmationCode(e.target.value)}
        />
        <TextField
          margin="normal"
          required
          fullWidth
          name="newPassword"
          label="New Password"
          type="password"
          id="newPassword"
          autoComplete="new-password"
          onChange={(e) => setNewPassword(e.target.value)}
        />
        <TextField
          margin="normal"
          required
          fullWidth
          name="newPasswordConfirm"
          label="Confirm New Password"
          type="password"
          id="newPasswordConfirm"
          autoComplete="new-password-confirm"
          onChange={(e) => setNewPasswordConfirm(e.target.value)}
        />
        <Button type="submit" fullWidth variant="contained" sx={{ mt: 3, mb: 2 }} disabled={loading}>
          {loading ? <CircularProgress size={24} /> : "Reset Password"}
        </Button>
        <Button onClick={() => resetPassword({ username })} type="button" fullWidth variant="outlined" sx={{ mb: 2 }}>
          Request new code
        </Button>
        <Button type="button" fullWidth variant="text" sx={{ mb: 2 }} onClick={() => navigate("/forgot-password")}>
          Go Back
        </Button>
      </Box>
      <Copyright />
    </CommonNonAuthenticatedPageLayout>
  );
};

export default PasswordReset;
